/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import Footer from "../../components/main/Footer"
import { Topbar } from "../../components/organisms/Topbar"
import { TENANTS } from "../../constants"
import { initPdiComponent } from "../../core/service/BusinessLogicService"
import BplsPendingScoreContent from "./components/BplsPendingScoreContent"
import "./styles.css"
import React, { useEffect } from "react"
import { Col, Container, Row } from "react-bootstrap"

export default function PendingScorePage({ tunnelData }) {
  const { tenant } = tunnelData

  useEffect(() => {
    initPdiComponent("PendingScorePage")
  }, [])

  return (
    <Container fluid>
      <Row noGutters>
        <Col className="misc-block">
          <Row>
            <Topbar tunnelData={tunnelData} displayToggleButton={false} />
            <Col sm={12}>
              <Container>
                <Row className="justify-content-center">{tenant === TENANTS.BPLS && <BplsPendingScoreContent />}</Row>
              </Container>
            </Col>
            <Col sm={12}>
              <Container>
                <Footer tunnelData={tunnelData} />
              </Container>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}
